import type { FC } from 'react';
import Icon from '../icons/Icon';
import styles from '~/components/routes/campaign/components/product-group/components/bring-your-own-device/BringYourOwnDevice.module.css';

export const DialogCloseButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <button onClick={onClick} className={styles.modalCloseBtn}>
    <Icon type="close" size={1.78} />
  </button>
);
